import { httpClient } from 'angieslist-app-platform';

// eslint-disable-next-line import/prefer-default-export
export const signServiceProviderAgreements =
  (serviceProviderId: string | number, groupType: string, os: string, env: string):
  any =>
    httpClient.post(`/gateway/service-provider-management/v1/service-provider/${serviceProviderId}/group-agreements`, {
      headers: {
        'X-ANGI-CallerType': 'ServiceProvider',
        'X-ANGI-CallerId': serviceProviderId,
      },
      body: {
        groupType,
        os,
        env,
      },
    });



// WEBPACK FOOTER //
// ./src/modules/adAgreement/common/service-provider-management-gateway/serviceProviderManagementService.js